  import { NavLink, useLocation } from "react-router-dom";
  const SettingsTabs = () => {
    const location = useLocation();
    const tabs = [
      { name: "General", path: "/settings/general/profile" },
      { name: "Website", path: "/settings/website/business" },
      { name: "App", path: "/settings/app/salary" },
      { name: "System", path: "/settings/system/email" },
      { name: "Financial", path: "/settings/financial/payment"},
      { name: "Other", path: "/settings/other/custom-css" },
    ];
    return (
      <div className="d-flex gap-3 border-bottom pb-2">
        {tabs.map((tab) => {
          const isActive = location.pathname.startsWith(
            tab.path.split("/")[2]
              ? `/settings/${tab.path.split("/")[2]}`
              : tab.path,
          );
          return (
            <NavLink
              key={tab.name}
              to={tab.path}
              className={`btn ${isActive ? "btn-primary" : "btn-light"}`}
            >
              {tab.name} Settings
            </NavLink>
          );
        })}
      </div>
    );
  };
  export default SettingsTabs;
